export default __webpack_public_path__ + "static/media/audit.c85f2bcd.svg";